export const schema = {
  type: "object",
  properties: {
    accountname: { type: "string" },
    website: { type: "string" },
    type: { type: "string" },
    description: { type: "string" },
    parentaccount: { type: "string" },
    accountowner: { type: "string" },
    phone: { type: "string" },
    billingstreet: { type: "string" },
    billingpostalcode: { type: "string" },
    billingcity: { type: "string" },
    billingcountry: { type: "string" },
    billingstate: { type: "string" },
    shippingstreet: { type: "string" },
    shippingpostalcode: { type: "string" },
    shippingcity: { type: "string" },
    shippingcountry: { type: "string" },
    shippingstate: { type: "string" },
  },
};
